import {PlusLoadForm} from '../../../fields/plusLoad/types'

export const buildPlusLoadForm = (): PlusLoadForm => {
  return {
    plusLoadExpected: false
  }
}
